module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "empty.ade72fe5.svg";